var _defs, _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "group_export",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 164 132",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".group-cls-1{stroke:#c9c9c9;stroke-miterlimit:10;}.group-cls-1,.group-cls-2{fill:#fff;}.group-cls-3{fill:#efeff2;}.group-cls-3,.group-cls-4,.group-cls-2{stroke-width:0px;}.group-cls-4{fill:#414141;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "background_-_component",
    className: "group-cls-3",
    width: 164,
    height: 132,
    rx: 4,
    ry: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "background_-_geneeral",
    className: "group-cls-2",
    x: 2,
    y: 2,
    width: 160,
    height: 128,
    rx: 4,
    ry: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "group"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "group-2",
    className: "group-cls-1",
    x: 5.38,
    y: 5,
    width: 74.5,
    height: 122,
    rx: 4,
    ry: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "group-3",
    className: "group-cls-1",
    x: 84.38,
    y: 5,
    width: 74.5,
    height: 122,
    rx: 4,
    ry: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "group-cls-4",
    d: "M122.33,62.5h-1.4v2.8h-2.8v1.4h2.8v2.8h1.4v-2.8h2.8v-1.4h-2.8v-2.8ZM121.62,59c-3.86,0-7,3.14-7,7s3.14,7,7,7,7-3.14,7-7-3.14-7-7-7ZM121.62,71.6c-3.09,0-5.6-2.51-5.6-5.6s2.51-5.6,5.6-5.6,5.6,2.51,5.6,5.6-2.51,5.6-5.6,5.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "group-cls-4",
    d: "M43.33,62.5h-1.4v2.8h-2.8v1.4h2.8v2.8h1.4v-2.8h2.8v-1.4h-2.8v-2.8ZM42.62,59c-3.86,0-7,3.14-7,7s3.14,7,7,7,7-3.14,7-7-3.14-7-7-7ZM42.62,71.6c-3.09,0-5.6-2.51-5.6-5.6s2.51-5.6,5.6-5.6,5.6,2.51,5.6,5.6-2.51,5.6-5.6,5.6Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupExport);
export default __webpack_public_path__ + "static/media/group_export.3a504097d4057d4760dd789b53a244d4.svg";
export { ForwardRef as ReactComponent };